import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import type { DataAction } from 'client/js/redux/types/dataAction.type';
import type { RootState } from 'client/js/redux/types/redux.types';
import type { CostFileTemplatesResponse } from 'shared/types/roi-hub/fileIngestion.types';
import { selectCostFileTemplateState } from '../CostFileTemplate.selectors';

export const ROI_COST_FILE_TEMPLATE_AD_PARTNERS = 'ROI_COST_FILE_TEMPLATE_AD_PARTNERS';

type Payload = {
  adPartners: Map<string, string>;
  lastUpdated: number;
};

export const getCostFileTemplateAdPartners = () => async (dispatch: any, getState: () => RootState) => {
  try {
    const state = getState();
    const costFileTemplateState = selectCostFileTemplateState(state);
    const currentLastUpdated = costFileTemplateState.lastUpdated;

    if (currentLastUpdated) {
      const lastUpdatedResponse = await dash_api.get<CostFileTemplatesResponse>(`/v1/roi/cost-file-templates`, {
        params: { sort: 'updated,DESC', limit: 1 },
      });
      const newLastUpdated = lastUpdatedResponse.data.data[0]?.updated || 0;
      if (newLastUpdated === currentLastUpdated) {
        return;
      }
      if (newLastUpdated === 0) {
        return dispatch({
          type: ROI_COST_FILE_TEMPLATE_AD_PARTNERS,
          data: { adPartners: [], lastUpdated: 0 },
        });
      }
    }

    const data: CostFileTemplatesResponse['data'] = [];
    const params = { limit: 200, page: 1 };
    let again: boolean = false;
    do {
      const response = await dash_api.get<CostFileTemplatesResponse>(`/v1/roi/cost-file-templates`, {
        params: { ...params, page: params.page++ },
      });
      data.push(...response.data.data);
      again = !!response.data.data.length && data.length < response.data.pagination.total;
    } while (again);

    const adPartners = data.reduce((map, template) => {
      map.set(template.ad_network, template.id);
      return map;
    }, new Map<string, string>());

    const lastUpdated = data.reduce((acc, { updated }) => {
      return updated > acc ? updated : acc;
    }, 0);

    return dispatch({
      type: ROI_COST_FILE_TEMPLATE_AD_PARTNERS,
      data: { adPartners, lastUpdated },
    });
  } catch (error) {
    NotificationActions.showNotification('Error occurred while retrieving cost file template ad networks', 'error');
    dispatch({
      type: ROI_COST_FILE_TEMPLATE_AD_PARTNERS,
      data: { adPartners: new Map(), lastUpdated: 0 },
    });
    throw error;
  }
};

export type GetCostFileTemplateAdPartnersAction = DataAction<typeof ROI_COST_FILE_TEMPLATE_AD_PARTNERS, Payload>;
